import { render, staticRenderFns } from "./WorkflowRoleEdit.vue?vue&type=template&id=b92ad5f6"
import script from "./WorkflowRoleEdit.vue?vue&type=script&lang=js"
export * from "./WorkflowRoleEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports